import ActionButton from "components/Buttons/ActionButton";
import SCRIPT_STATUS from "enums/SCRIPT_STATUS";
import useCreateOrUpdateScript from "hooks/api/useCreateOrUpdateScript";
import useNavigateToScripts from "hooks/navigation/useNavigateToScripts";
import useFormHelpers from "../FormScript/hooks/useFormHelpers";

export default function BtnDuplicate() {
  const { createOrUpdateScript, isWriting } = useCreateOrUpdateScript();
  const navigateToScripts = useNavigateToScripts();
  const { payload } = useFormHelpers();

  function onDuplicate() {
    const duplicatePayload = { ...payload };
    duplicatePayload.id = "";
    duplicatePayload.title = `Copy of ${payload.title}`;
    duplicatePayload.status = SCRIPT_STATUS.DRAFT;

    createOrUpdateScript(duplicatePayload).then(() => navigateToScripts("/"));
  }

  return (
    <ActionButton disabled={isWriting} onClick={onDuplicate}>
      DUPLICATE
    </ActionButton>
  );
}
